export const ANNOTATION_OPENAPI_LINTER_PROCESSOR =
  'backstage.io/openapi-linter-processor';
